import { useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import useHttpUtility from "../utilities/useHttpUtility";

export default function AccountDetails({ client, contact }) {
    const navigate = useNavigate();
    const http = useHttpUtility(true);
    const [showNotification, showPrompt] = useOutletContext();

    function handleLogout() {
        showPrompt(
            "Disconnect Account",
            "Are you sure you want to disconnect your Urgent Couriers account? You will need to log in again to manage settings.",
            () => {
                http.post(
                    "/api/Auth/Logout",
                    {},
                    () => {
                        // Reload the page to go back to login
                        window.location.reload();
                    },
                    () => {
                        // Error already handled by http utility
                    }
                );
            }
        );
    }

    return (
        <div className="account-details">
            <b>Contact:</b>&nbsp;{contact ? `${contact.firstName} ${contact.lastName}` : "( --Undefined-- )"}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <b>Client Code:</b>&nbsp;{client ? client.code : "( --Undefined-- )"}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <b>Status:</b>&nbsp;{contact?.active && client?.active ? "Active" : "Inactive"}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {contact && (
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={handleLogout}
                    title="Disconnect your Urgent Couriers account"
                >
                    Disconnect
                </button>
            )}
        </div>
    );
}